const RESERVATION_STATUS = {
    BOOKED: 1,
    PENDING: 5,
    CANCELED: -5,
}

export { RESERVATION_STATUS }
export default RESERVATION_STATUS



// WEBPACK FOOTER //
// ./src/enums/reservationStatus.js